export default "__VITE_PUBLIC_ASSET__1d55d7ac__"